// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { _ } from "~/i18n";

Mapy.Loader = class {
	constructor() {
		this._request = 0;
		this._hideRequest = 0;
		this._progress = 0;
		this._resetTimeout = null;
		this._timeout = null;
		this._firstLoad = true;
		this._loadEndTimeout = null;
		this._dom =  {
			container: node("div", { className: "loader-big" }),
			loader: node("img", { src: "/img/loader.gif", width: 24, height: 24 }),
			text: node("span", { innerHTML: _("loader") })
		};
	}

	getBigCon() {
		return this._dom.container;
	}

	getFirstLoad() {
		return this._firstLoad;
	}

	skipFirstLoad() {
		if (this._firstLoad) {
			this._firstLoad = false;
		}
	}

	start(show, noSync) {
		// zjistime, zda jsme prvni v poli volajicich
		if (this._request == 0 && show) {
			this._resetBigLoader();
		}

		if (show && !noSync) {
			this._timeout = window.setTimeout(this._addText.bind(this), 3000);
			this.sync();
		}

		if (show) {
			if (this._resetTimeout) {
				this._resetTimeout = this._clearTimeout(this._resetTimeout);
			}
			this._request++;
		}
		else {
			this._hideRequest++;
		}
	}

	end(show) {
		if ((this._request + this._hideRequest) == 0) { return; }

		if (show) {
			if (this._request == 1) {
				Mapy.Util.clear(this._dom.container);
				this._timeout = this._clearTimeout(this._timeout);
			}

			this._request--;
		}
		else {
			this._hideRequest--;
		}

		if (this._resetTimeout) {
			this._resetTimeout = this._clearTimeout(this._resetTimeout);
		}

		if ((this._request + this._hideRequest) == 0) {
			this._resetTimeout = window.setTimeout(
				() => {
					this._loadEnd();
				}, 600);
		}
	}

	sync() {
		if (this._dom.container.parentNode && this._dom.container.parentNode.nodeType == 1) {
			var con = this._dom.container,
				body = Mapy.getComponent("layout").getBody(),
				bodyHeight = body.offsetHeight,
				children = body.childNodes,
				height = 0;

			for (var i = 0; i < children.length; i++) {
				height += children[i].offsetHeight;
			}

			let half = (bodyHeight - height) / 2;
			if (half > 1) {
				con.style.paddingTop = (half - 1) + "px";
				con.style.paddingBottom = (half - 1) + "px";
			}
		}
	}

	_addText() {
		this._timeout = null;
		this._dom.text.style.opacity = 1;
	}

	_clearTimeout(timeout) {
		if (timeout) {
			window.clearTimeout(timeout);
			timeout = null;
			return timeout;
		}
	}

	_resetBigLoader(timeout) {
		this._dom.container.appendChild(this._dom.loader);
		this._dom.container.appendChild(this._dom.text);
		this._dom.container.style.paddingTop = "";
		this._dom.container.style.paddingBottom = "";
		this._dom.text.style.opacity = 0;
		// eslint-disable-next-line no-unused-expressions
		this._dom.text.offsetWidth;
	}

	_loadEnd () {
		if (this._loadEndTimeout) {
			this._loadEndTimeout = this._clearTimeout(this._loadEndTimeout);
		}

		this._loadEndTimeout = window.setTimeout(function(){
			if (this._firstLoad) {
				Mapy.setPhantomMeta(200);
				this._firstLoad = false;
			}
		}.bind(this), 300);
	}
};
